import axios from "../../../../../@core/axios"

export const selectCurrentContest = (contest) => async (dispatch) =>
  // eslint-disable-next-line implicit-arrow-linebreak
  dispatch({ type: "SELECT_CURRENT_CONTEST", data: contest })

export const addContest = (contestData, history, companyId) => async (dispatch) => {
  try {
    const { data } = await axios.post("api/contest", { contestData, companyId })

    dispatch({ type: "SELECT_CURRENT_CONTEST", data: data.contest })
    dispatch({ type: "ADD_CONTESTS", data: data.contest })
    dispatch({ type: "SET_CONTESTANTS", data: data.contestants.contestants })
    dispatch({ type: "UPDATE_USER", data: data.contest._id })

    history.push("/apps/contests")
  } catch (err) {
    console.log(err)
  }
}

export const getContest = async (companyId) => {
  try {
    const { data } = await axios.get(`/api/contest/${companyId}`)

    return data
  } catch (err) {
    console.log(err)
  }
}

export const getContests = (companyId) => async (dispatch) => {
  try {
    const { data } = await axios.get(`/api/contest/all/${companyId}`)

    dispatch({
      type: "GET_CONTESTS",
      data
    })
  } catch (err) {
    console.log(err)
  }
}

export const updateContest = (id, updatedData) => async (dispatch) => {
  try {
    const { data } = await axios.patch(`/api/contest/${id}`, { updatedData })
    dispatch({
      type: "UPDATE_CONTEST",
      data
    })
  } catch (err) {
    console.log(err)
  }
}

export const deleteContest = (id) => async (dispatch) => {
  try {
    const { data } = await axios.delete(`/api/contest/${id}`)
    dispatch({
      type: "DELETE_CONTEST",
      data
    })
  } catch (err) {
    console.log(err)
  }
}
